import { useNavigate } from "react-router-dom";
import ajaxStations from "../../util/remote/ajaxStations";
import ajaxSuppliers from "../../util/remote/ajaxSuppliers";
import ajaxDeliveries from "../../util/remote/ajaxDeliveries";
import ajaxFuelTanks from "../../util/remote/ajaxFuelTanks";
import { useContext, useEffect, useState } from "react";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import AuthContext from "../../Context/AuthContext";
const RegisterDeliveryModal = (props) => {
  const { userId } = useContext(AuthContext); // recieved_by_id
  const station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));
  const [loading, setLoading] = useState(false);
  // Form values
  const [station_id, setstation_id] = useState(station_idd);
  const [supplierID, setSupplierID] = useState(null);
  const [tankID, setTankID] = useState(null);
  const [truckNumberPlate, setTruckNumberPlate] = useState("");
  const [quantity, setQuantity] = useState("");
  const [dateRecieved, setDateRecieved] = useState("");
  const [stations_company_id, setstations_company_id] = useState("");
  // Dropdown lists
  const [suppliers, setSuppliers] = useState([]);
  const [stations, setStations] = useState([]);
  const [tanks, setTanks] = useState([]);
  const navigate = useNavigate();
  // Fetch stations
  const fetchStations = async () => {
    setLoading(true);
    const response = await ajaxStations.liststations_mini_data();
    if (response.status === "OK") {
      const list =
        Array.isArray(response.details) &&
        Array.isArray(response.details) &&
        response.details.map((d) => ({
          value: Number(d.id), // <-- FIX: convert ID to number
          label: d.station_name,
        }));
      setStations(list);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  // Get station mother company
  const fetchStationMotherStation = async () => {
    setLoading(true);
    const data = { station_id: station_id };
    const response = await ajaxStations.get_station_mother_company_id(data);
    if (response.status === "OK") {
      setstations_company_id(response.details);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchStationMotherStation();
  }, [station_id]);
  // get the suppliers
  const fetchSuppliers = async () => {
    setLoading(true);
    const data = { stations_company_id: stations_company_id };
    const response = await ajaxSuppliers.list_supplier_mini(data);
    if (response.status === "OK") {
      setSuppliers(
        Array.isArray(response.details) &&
          response.details.map((d) => ({ value: d.id, label: d.name }))
      );
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchSuppliers();
  }, [stations_company_id]);
  // Fetch tanks for selected station
  const fetchTanks = async () => {
    if (!station_id) return;
    const response = await ajaxFuelTanks.list_fuel_tanks({
      station_id: station_id,
    });
    if (response.status === "OK") {
      setTanks(
        Array.isArray(response.details) &&
          response.details.map((t) => ({
            value: t.id,
            label: `${t.Tank_code} (${t.capacity}L)`,
          }))
      );
    }
  };
  useEffect(() => {
    fetchStations();
    fetchSuppliers();
  }, []);
  useEffect(() => {
    fetchTanks();
  }, [station_id]);
  // Validation
  const allRowsFilled = () =>
    supplierID &&
    station_id &&
    tankID &&
    truckNumberPlate &&
    quantity &&
    dateRecieved;
  // Submit
  const handleAdd = async (e, closeModal) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields.");
      return;
    }
    const data = {
      supplier_id: supplierID,
      station_id: station_id,
      tank_id: tankID,
      recieved_by_id: userId,
      truck_number_plate: truckNumberPlate,
      quantity: quantity,
      date_recieved: dateRecieved,
    };
    setLoading(true);
    const response = await ajaxDeliveries.create_delivery(data);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      props.func();
      setTimeout(() => {
        closeModal();
      }, 2000);
    } else {
      toast.error(response.message);
    }
  };
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleAdd(e, controls.close)}
        disabled={!allRowsFilled() || loading}
      >
        {loading ? <Loader /> : "Record Delivery"}
      </button>
    </>
  );
  return (
    <SystemModal
      title="Record New Fuel Delivery"
      size="md"
      footer={RenderFooter}
    >
      <Toaster />
      {loading && <Loader />}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <form onSubmit={handleAdd}>
                  <div className="row mb-3">
                    {/* Station */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Station <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={stations}
                        value={stations.find((c) => c.value === station_id)}
                        onChange={(selected) => setstation_id(selected.value)}
                        placeholder="Select station"
                        isDisabled
                      />
                    </div>
                    {/* Supplier */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Supplier <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={suppliers}
                        value={suppliers.find((c) => c.value === supplierID)}
                        onChange={(selected) => setSupplierID(selected.value)}
                        placeholder="Select supplier"
                      />
                    </div>
                    {/* Tank */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Tank <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={tanks}
                        value={tanks.find((c) => c.value === tankID)}
                        onChange={(selected) => setTankID(selected.value)}
                        placeholder="Select tank"
                      />
                    </div>
                    {/* Truck Number */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Truck Number Plate
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={truckNumberPlate}
                        onChange={(e) => setTruckNumberPlate(e.target.value)}
                        placeholder="Enter truck number plate"
                      />
                    </div>
                    {/* Quantity */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Quantity (Liters)
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                        placeholder="Enter quantity delivered"
                      />
                    </div>
                    {/* Date */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Date Received <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        value={dateRecieved}
                        onChange={(e) => setDateRecieved(e.target.value)}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
export default RegisterDeliveryModal;
